import { Link } from "react-router-dom";
import { hotTags } from "@/mocks/home";
import { films } from "@/mocks/films";
import { stars } from "@/mocks/stars";
import { topics } from "@/mocks/topics";

function resolveTagLink(tag: string): string {
  const topic = topics.find((item) => item.title.includes(tag));
  if (topic) return `/detail/topic/${topic.id}`;
  const film = films.find((item) => item.title.includes(tag));
  if (film) return `/detail/film/${film.id}`;
  const star = stars.find((item) => item.name.includes(tag));
  if (star) return `/detail/star/${star.id}`;
  return `/search?q=${encodeURIComponent(tag)}`;
}

export default function HotTagCloud() {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h3 className="mb-3 flex items-center gap-2 text-base font-bold text-foreground-950">
        <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
        热门话题标签
      </h3>
      <div className="flex flex-wrap gap-2">
        {hotTags.map((tag, index) => (
          <Link
            key={tag}
            to={resolveTagLink(tag)}
            className={`whitespace-nowrap rounded-full px-3 py-1 text-xs transition-colors ${
              index < 3
                ? "bg-accent-100 text-accent-900 hover:bg-accent-200"
                : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
            }`}
          >
            {index < 3 && <i className="ri-fire-fill mr-0.5 text-[10px]" aria-hidden="true"></i>}
            {tag}
          </Link>
        ))}
      </div>
    </div>
  );
}